//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'NYU_PHFI',
  data () {
    return {
      defaultJson: {
        '症状和体征': '症状和体征',
        '肝脏增大': '肝脏增大',
        '呼吸急促，呼吸困难': '呼吸急促，呼吸困难',
        '药物治疗': '药物治疗',
        '循环生理': '循环生理'
      },
      form: {
        data1: '0',
        data2: '0',
        data3: '0',
        data4: '0',
        data5: '0',
        data6: '0',
        data7: '0',
        data8: '0',
        data9: '',
        data10: '0',
        data11: '',
        data12: '0',
        data13: '0',
        data14: '',
        data15: '0',
        data16: '0',
        data17: '0',
        data18: '0',
        data19: '0',
        data20: '0'
      },
      dataList9: [
        {value: '1', name: '＜肋下4cm', shortName: '＜肋下4cm'},
        {value: '2', name: '＞肋下4cm', shortName: '＞肋下4cm'}
      ],
      dataList11: [
        {value: '1', name: '轻至中度', shortName: '轻至中度'},
        {value: '2', name: '中至重度', shortName: '中至重度'}
      ],
      dataList14: [
        {value: '1', name: '利尿剂小至中等剂量', shortName: '小至中等剂量'},
        {value: '2', name: '利尿剂中等剂量至大剂量', shortName: '中等剂量至大剂量'}
      ],
      hasScore: false,
      disabled: false
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      console.log(form, 7777)
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            form[key] = 0
          } else {
            console.log(key, form[key], 8888)
            form[key] = Number(form[key])
          }
        }
      }

      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        const data1 = form.data1 ? 2 : 0
        const data2 = form.data2 ? 2 : 0
        const data3 = form.data3 ? 2 : 0
        const data4 = form.data4 ? 1 : 0
        const data5 = form.data5 ? 1 : 0
        const data6 = form.data6 ? 2 : 0
        const data7 = form.data7 ? 1 : 0
        const data8 = form.data8 ? 2 : 0
        const data13 = form.data13 ? 1 : 0
        const data16 = form.data16 ? 1 : 0
        const data17 = form.data17 ? 1 : 0
        const data18 = form.data18 ? 2 : 0
        const data19 = form.data19 ? 2 : 0
        const data20 = form.data20 ? 2 : 0
        // weight + airways + systolicBP + cns + cutaneousWound + fracture
        let result = data1 + data2 + data3 + data4 + data5 + data6 + data7 + data8 + form.data9 + form.data11 +
           +data13 + form.data14 + data16 + data17 + data18 + data19 + data20
        self.hasScore = true
        if (result >= 30) {
          return '30'
        }

        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/NYU_PHFI.vue